import React from 'react';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import './App.css';
import LockerAsignmentPag from './LockerAsignmentPag';
import LockerPairingPage from './LockerPairingPage';
import ProvisioningGate from './ProvisioningGate';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <div className="bubbles">
                {Array.from({ length: 10 }).map((_, i) => (
                  <span key={i} className="bubble" />
                ))}
              </div>
              <header className="App-header">
                <h1>Cordura Locker</h1>
                <p className="App-subheader"><em>...comming soon</em></p>
                <div className="App-buttons">
                  <Link className="App-button" to="/assign-lockers">Assign lockers</Link>
                </div>
              </header>
            </div>
          }
        />
        <Route path="/assign-lockers" element={<ProvisioningGate><LockerAsignmentPag /></ProvisioningGate>} />
        <Route path="/assignlocker" element={<ProvisioningGate><LockerAsignmentPag /></ProvisioningGate>} />
        <Route path="/pair-locker" element={<ProvisioningGate><LockerPairingPage /></ProvisioningGate>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
